import { ref } from "vue"

class Abilities {

    /**
     * Abilities list
     * 
     * @type {array}
     */
    abilities = ref([])


    /**
     *  Define abilities
     * 
     * @param {array} permissions
     * @returns {void} 
     * 
     * @example
     * defineAbility([
     *    {
            action: 'auth.login',
            subject: ['Admin', 'Manager', 'Guest']
         },
     * ])
     */
    defineAbility = (permissions = []) => {
        this.abilities.value = permissions
    }


    /**
     * Check if user has ability
     * 
     * @param {string} action what to access
     * @param {string} subject who can access
     * @returns {boolean} default: false
     */
    can = (action = '', subject = '') => {
        let p = this.abilities.value.find(ability => ability.action == action && ability.subject.includes(subject))

        return p ? true : false
    }
}

const ability = new Abilities()

export default ability